import type { ComponentProps } from 'react'

import { ICON_DEFAULT_COLOR, ICON_DEFAULT_FILL, type IconProps } from 'components'

export const TableProperties = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = '24', // TODO: Replace with ICON_DEFAULT_WIDTH when migration to ION is complete
  height = '24', // TODO: Replace with ICON_DEFAULT_HEIGHT when migration to ION is complete
  viewBox = '0 0 24 24', // TODO: Replace with ICON_DEFAULT_VIEWBOX when migration to ION is complete
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.25 15.75H15.75V20.25H19C19.6904 20.25 20.25 19.6904 20.25 19V15.75ZM15.75 14.25H20.25V9.75H15.75V14.25ZM3.75 14.25H14.25V9.75H3.75V14.25ZM3.75 19C3.75 19.6904 4.30964 20.25 5 20.25H14.25V15.75H3.75V19ZM20.25 5C20.25 4.30964 19.6904 3.75 19 3.75H15.75V8.25H20.25V5ZM3.75 8.25H14.25V3.75H5C4.30964 3.75 3.75 4.30964 3.75 5V8.25ZM21.75 19C21.75 20.5188 20.5188 21.75 19 21.75H5C3.48122 21.75 2.25 20.5188 2.25 19V5C2.25 3.48122 3.48122 2.25 5 2.25H19C20.5188 2.25 21.75 3.48122 21.75 5V19Z"
        fill={color}
      />
    </svg>
  )
}
